module.exports = __webpack_public_path__ + "img/icon_kehu_03.ca2719e4.png";